import tw from 'tailwind-styled-components'

export const TwTasks = tw.div`
  w-full
  bg-primary
`

export const TwTabsWrapper = tw.div`
  p-16
  pl-28
  flex
  items-center
  
  border-0
  border-solid
  border-b-1
  border-base
`

export const TwContentWrapper = tw.div`
`
